import type { CompanyType, QuickscanResult } from '@wtta/scoring'

interface ReportHeaderProps {
  result: QuickscanResult
  companyType: CompanyType
  generatedAt: Date
}

const RISK_HEADLINE: Record<QuickscanResult['riskLevel'], string> = {
  low: 'Je bent goed voorbereid op de WTTA',
  medium: 'Je bent op de goede weg, maar er zijn aandachtspunten',
  high: 'Er zijn substantiële stappen nodig vóór de WTTA-ingangsdatum',
}

const COMPANY_LABEL: Record<CompanyType, string> = {
  uitlener: 'uitlener',
  inlener: 'inlener',
}

const DATE_FORMATTER = new Intl.DateTimeFormat('nl-NL', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export function ReportHeader({ result, companyType, generatedAt }: ReportHeaderProps) {
  return (
    <header className="report-header" data-testid="report-header">
      <p className="report-header__eyebrow">
        WTTA Quickscan rapport · {COMPANY_LABEL[companyType]} · {DATE_FORMATTER.format(generatedAt)}
      </p>
      <h1 className="report-header__title">{RISK_HEADLINE[result.riskLevel]}</h1>
      <div className={`report-header__score report-header__score--${result.riskLevel}`}>
        <span className="report-header__score-value">{result.readinessPercentage}%</span>
        <span className="report-header__score-label">readiness</span>
      </div>
    </header>
  )
}
